import React from 'react'
import AllCapsules from '../../components/Capsules/All/AllCapsules'
const AllCapusle = () => {
    return (
        <AllCapsules />
    )
}

export default AllCapusle
